import { RefreshCcw01 } from '@untitledui/icons'

import Button from '@components/designSystem/Button'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { cx } from '@utils/cx'

interface ResetZoomButtonProps {
  resetZoom: () => void
  showButton: boolean
}

function ResetZoomButton({ resetZoom, showButton }: ResetZoomButtonProps) {
  const { t } = useTypedTranslation()

  return (
    <div
      className={cx(
        'absolute bottom-8 flex w-full justify-center transition-all duration-300',
        showButton ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0' // animate button appearance
      )}
    >
      <Button
        variant='dark'
        iconLeading={<RefreshCcw01 />}
        isDisabled={!showButton}
        onClick={() => resetZoom()}
        aria-label={t('storeMap.controls.reset')}
      >
        {t('storeMap.controls.reset')}
      </Button>
    </div>
  )
}

export default ResetZoomButton